import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function useLocaleRefresh(refetchCallback: () => void) {
  const { i18n } = useTranslation();

  useEffect(() => {
    refetchCallback();
  }, [i18n.language]);
}
